<template>
  <div style="display: flex;align-content: center;padding-left: 5px;">
    <span style="font-weight: bold;font-size: 13px;">{{ total.currency }}</span>
    <span :style="style">{{ total.amount }}</span>
  </div>
</template>

<script>

export default {
  name: 'ChargeCountItemRenderer',
  props: {
    item: {
      type: Object, required: true
    }
  },
  computed: {
    style() {
      const initStyle = this.item.style || { 'text-decoration': this.item.textDecoration ? 'underline' : 'none' }
      const { amount } = this.item
      return { 'font-style': 'oblique', 'text-decoration': 'none', ...initStyle, 'font-size': '12px', color: Number(typeof amount === 'object' ? amount.toNumber() : 0) < 0 ? '#ff0000' : '#000000' }
    },
    total() {
      const { item } = this
      const currency = item.countName ? item.countName + '(' + item.currency + '):' : item.currency + ':'
      const amount = typeof item.amount === 'object' ? item.amount.toFormat(2) : item.amount
      const result = { ...item, currency, amount: (amount === 'Infinity') ? '' : amount }
      console.log(typeof item.amount === 'object', result)
      return result
    }
  }
}
</script>

<style scoped>

</style>
